function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { marked } from "marked";

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "markdown",
    value: function markdown(text) {
      return marked(text);
    }
  }, {
    key: "local_iso8601",
    value: function local_iso8601(date) {
      // See https://stackoverflow.com/a/29774197
      var offset = date.getTimezoneOffset();
      return new Date(date.getTime() - offset * 60 * 1000).toISOString(); // return yourDate.toISOString().split("T")[0];
    }
  }]);

  return _default;
}();

export { _default as default };